module.exports = __webpack_public_path__ + "static/haris_bjelic-24f3c0e2dd0d028654fc3dc9675d31b8.jpg";